import { Component } from '@angular/core'

@Component({
  selector: 'se-po-edit-persona-modal-docs',
  templateUrl: './edit-persona-modal-docs.component.html',
  styleUrls: ['./edit-persona-modal-docs.component.scss'],
  standalone: false,
})
export class EditPersonaModalDocsComponent {
}
